import { Flash } from '@primer/react';

const UnAuthorizedPage = () => {
    return (
        <Flash variant='danger'>
            UnAuthorized!
        </Flash>
    );
};

export default UnAuthorizedPage;